import { Injectable } from '@angular/core';
import { ThemesService } from '../themes/themes.service';
import { Funcionalidade } from '../../util/enum/funcionalidade.enum';
import { PermissaoModel } from '../../util/model/permissao.model';

@Injectable()
export class MenuService {

    menuItems: Array<any>;

    constructor(private themesService: ThemesService) {
      this.cleanMenu();
    }

    addMenu(items: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        funcionalidade?: Funcionalidade,
        submenu?: Array<any>
    }>, permissoes: {[key: string]: PermissaoModel}) {
        this.themesService.setTheme('E');
        this.cleanMenu();
        items.forEach((item) => {
          if(this.possuiPermissao(permissoes, item.funcionalidade)){
            this.menuItems.push(item);
          }
        });
    }

    possuiPermissao(permissoes: {[key: string]: PermissaoModel}, fundionalidade: Funcionalidade){
      if(permissoes == null || fundionalidade == null || fundionalidade == undefined) {
          return false;
      }

      return (permissoes[fundionalidade] != null && permissoes[fundionalidade] != undefined && (permissoes[fundionalidade].somenteLeitura || permissoes[fundionalidade].acessoTotal));
   }

    getMenu() {
        return this.menuItems;
    }

    cleanMenu() {
      this.menuItems = [];
    }

}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts